module.exports = __webpack_public_path__ + "media/images/icons/check-circle-488d357c9349218cf5a0b2a03d6ba313.svg";